<template>
  <div class="menu-container" data-testid="yard-view-mode-menu">
    <v-menu :persistent="false">
      <template #activator="{ props }">
        <v-btn
          variant="outlined"
          color="darken-2"
          v-bind="props"
          :ripple="false"
          data-testid="yard-view-mode-menu-activator"
          aria-owns="yard-view-view-mode-options">
          <v-icon size="small" start>
            {{ getViewModeMeta().icon }}
          </v-icon>
          {{ getViewModeMeta().label }}
          <v-icon size="small" class="ml-2" end>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list id="yard-view-view-mode-options" data-testid="view-mode-options" density="compact">
        <v-list-item
          v-for="viewMode in viewModes"
          :key="viewMode"
          :value="viewMode"
          :disabled="getViewModeMeta(viewMode).disabled"
          @click="setViewMode(viewMode)">
          <template #prepend>
            <v-icon size="x-small">{{ getViewModeMeta(viewMode).icon }}</v-icon>
          </template>
          <v-list-item-title>
            {{ getViewModeMeta(viewMode).label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { YardViewModeEnum } from '@nova/core';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewModeSelect',
  setup() {
    const yardStore = useYard();
    const { t } = useI18n();

    const trackMixpanelEvent = viewMode => {
      yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.SWITCH_VIEW_MODE, {
        metadata: {
          switch_mode_to:
            viewMode === YardViewModeEnum.GRID
              ? t('global.specialtyTerms.gridView')
              : t('global.specialtyTerms.listView')
        }
      });
    };

    const setViewMode = viewMode => {
      yardStore.viewModeRef.value = viewMode;
      trackMixpanelEvent(viewMode);
    };

    const getViewModeMeta = viewMode => {
      let icon = 'mdi-grid';
      let label = t('global.basicTerms.view').toLowerCase();
      let disabled = false;

      switch (viewMode ?? yardStore.viewModeRef.value) {
        case YardViewModeEnum.GRID:
          icon = 'mdi-grid';
          label = `${t('global.basicTerms.grid')} ${label}`;
          disabled = false;
          break;
        case YardViewModeEnum.LIST:
          icon = 'mdi-format-list-checkbox';
          label = `${t('global.basicTerms.list')} ${label}`;
          disabled = false;
          break;
        case YardViewModeEnum.TV:
          icon = 'mdi-television-play';
          label = `${t('global.specialtyTerms.tvMode')} (${t('global.basicTerms.soon')})`;
          disabled = true;
          break;
      }
      return { icon, label, disabled };
    };

    return {
      getViewModeMeta,
      setViewMode,
      YardViewModeEnum,
      viewModes: Object.values(YardViewModeEnum),
      t
    };
  }
});
</script>
